import { Project } from "../Project/Project.type";
import { User } from "../User/User.type";
import { ApiCallState } from "../Utils";

export type ContractMeetingActionPlan = {
  id?: number;
  contract_meeting_id?: number;
  task: string;
  assigned_to: string;
  schedule_by?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type ContractMeeting = {
  id: any;
  project_id: number;
  consultant_id: number;
  date: string;
  meeting_no: string;
  opening_remarks: string;
  additional_issues: string;
  action_plans: ContractMeetingActionPlan[];
  user_id: number;
  creator?: User;
  consultant?: User;
  project?: Project;
  createdAt?: string;
  updatedAt?: string;
};

export type ContractMeetingStateTypes = {
  fetchAll: ApiCallState<ContractMeeting[]>;
  fetchOne: ApiCallState<ContractMeeting | {}>;
};

export const ContractMeetingActionTypes = {
  FETCH_ALL_CONTRACT_MEETING: "FETCH_ALL_CONTRACT_MEETING",
  FETCH_ALL_CONTRACT_MEETING_RESET: "FETCH_ALL_CONTRACT_MEETING_RESET",
  FETCH_ALL_CONTRACT_MEETING_FAILURE: "FETCH_ALL_CONTRACT_MEETING_FAILURE",
  FETCH_ALL_CONTRACT_MEETING_SUCCESS: "FETCH_ALL_CONTRACT_MEETING_SUCCESS",

  FETCH_ONE_CONTRACT_MEETING: "FETCH_ONE_CONTRACT_MEETING",
  FETCH_ONE_CONTRACT_MEETING_RESET: "FETCH_ONE_CONTRACT_MEETING_RESET",
  FETCH_ONE_CONTRACT_MEETING_FAILURE: "FETCH_ONE_CONTRACT_MEETING_FAILURE",
  FETCH_ONE_CONTRACT_MEETING_SUCCESS: "FETCH_ONE_CONTRACT_MEETING_SUCCESS",
};
